import { axiosInstanceWithCredentials, axiosInstance } from "./base";

export function getFamilies(params) {
  return axiosInstanceWithCredentials.get("/families", {
    params
  });
}
export function updateFamily(id, data) {
  return axiosInstanceWithCredentials.put(`/family/${id}/`, data);
}
export function deleteFamily(id) {
  return axiosInstanceWithCredentials.delete(`/family/${id}/`);
}
export function resetPassword(data) {
  return axiosInstance.put("/family/password/reset", data);
}
